<div #anchor class="observeMe" *ngIf="!downScroll"></div>
<ng-content></ng-content>
<div #anchor class="observeMe" *ngIf="downScroll"></div>
